import React from "react";
import { FxRenderer } from "../fxms/datas/FxRenderer";
import { useEffect } from "react";
import { useState } from "react";
import { FxmsData } from "../fxms/datas/FxData";
import { FxResource } from "../fxms/inputs/FxResource";
import { FxmsContentDashboardDialog, FxWindow } from "../fxms/windows/FxWindows";

const AlamNotify = (props) => {
  const { dataRows } = props;
  const opObjUi = FxmsData.getOpObj("ui-3-3");
  const [alarmCurrent, setAlarmCurrent] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  /*알림 넘기기 */
  useEffect(() => {
    const refreshAlarm1 = setInterval(() => {
      setAlarmCurrent((alarmCurrent) => alarmCurrent + 1);
    }, 5000);
    return () => clearInterval(refreshAlarm1);
  }, []);

  let idx = alarmCurrent;
  if (alarmCurrent == dataRows.alarmFetchData.length) {
    setAlarmCurrent(0);
    idx = 0;
  }

  return (
    <ul className="notice">
      <div
        className="notice_container"
        style={{ transform: `translateY(-${30 * alarmCurrent}px)` }}
      >
        {dataRows.alarmFetchData.map((item, alarmCurrent) => {
          return (
            <li className="notice_content" key={alarmCurrent}>
              <div>
                <div 
                  className="notice_title" 
                  onClick={() => {
                    FxWindow.showNavigator(opObjUi.menuFullName);
                    setDialogOpen(true);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {item["moName"]}에서 {item["alarmMsg"]}- (
                  {FxRenderer.renderDate(item["occurDtm"])})-
                  {item["inloName"]}
                </div>
              </div>
            </li>
          );
        })}

        <FxmsContentDashboardDialog
          open={dialogOpen}
          closeModal={() => setDialogOpen(false)}
          dialogTitle={'설비관리/알림조회'}
          opObj={opObjUi}
        >
          <FxResource menu={opObjUi}/>
        </FxmsContentDashboardDialog>
      </div>
    </ul>
  );
};

export default AlamNotify;
